// extracted by mini-css-extract-plugin
export var bkgOverlay = "Modal-module--bkgOverlay--739e6";
export var closeBtn = "Modal-module--closeBtn--e1c55";
export var modal = "Modal-module--modal--34915";
export var modalContent = "Modal-module--modalContent--09cfc";
export var modalHeader = "Modal-module--modalHeader--9f775";